/**
 * @generated SignedSource<<f3c66b83bb0392eda353c0f3dd9a1852>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountsSubmitStripe_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "CheckoutBankAccountsSubmitStripe_viewer";
};
export type CheckoutBankAccountsSubmitStripe_viewer$key = {
  readonly " $data"?: CheckoutBankAccountsSubmitStripe_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountsSubmitStripe_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountsSubmitStripe_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f8c48e2620e0da75df8cf3911ad434e9";

export default node;
